export function formatNumber(value) {
    const num = Number(value);

    // handle invalid numbers
    if (Number.isNaN(num)) return value;

    // integer → no decimals
    if (Number.isInteger(num)) return num;

    // decimals → max 2
    return parseFloat(num.toFixed(2));
}
